export default __webpack_public_path__ + "static/media/16_tag_kitchen.e00a905d.svg";